var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 42.01,
    viewBox: "0 0 56 42.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gmail-Logo.wine",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14712",
    "data-name": "Path 14712",
    d: "M3.818,48.2h8.909V26.562L0,17.016V44.38A3.817,3.817,0,0,0,3.818,48.2Z",
    transform: "translate(0 -6.188)",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14713",
    "data-name": "Path 14713",
    d: "M68,48.2h8.909a3.817,3.817,0,0,0,3.818-3.818V17.016L68,26.562Z",
    transform: "translate(-24.727 -6.188)",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14714",
    "data-name": "Path 14714",
    d: "M68,3.828V20.374l12.727-9.545V5.738a5.727,5.727,0,0,0-9.164-4.582Z",
    transform: "translate(-24.727 0)",
    fill: "#fbbc04"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14715",
    "data-name": "Path 14715",
    d: "M20,22.562V6.016L35.273,17.471,50.545,6.016V22.562L35.273,34.016Z",
    transform: "translate(-7.273 -2.188)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14716",
    "data-name": "Path 14716",
    d: "M0,5.738v5.091l12.727,9.545V3.828L9.164,1.156A5.727,5.727,0,0,0,0,5.738Z",
    transform: "translate(0 0)",
    fill: "#c5221f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/gmail_logo.8e0a2a1b52efe7256ebe8e4bbd8b7bc5.svg";
export { ForwardRef as ReactComponent };